import FocusTrap from 'focus-trap-react';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../Accessibility/KeyboardEvents';
import clickOutsideStore from '../../ClickOutsideStore';
import { Link } from 'react-router-dom';
import { T } from '../../Translations';
import clsx from 'clsx';
import { currentUserStore } from '../../CurrentUserStore';
import { findLink } from '../../LinkyLinky';

type State = {
  isOpen: boolean;
};

export interface Props {
  header: React.JSX.Element;
  ariaLabelledby?: string;
}

const generateId = (min: number, max: number) => {
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return `#dropdown-container_${randomNumber}`;
};

class Dropdown extends React.Component<Props> {
  dropdownRef: React.RefObject<HTMLDivElement | null> = React.createRef();
  state: State = {
    isOpen: false,
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  toggle = () => {
    const { isOpen } = this.state;
    clickOutsideStore.addListener({ ref: this.dropdownRef, callback: this.close });
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { isOpen } = this.state;
    const uniqueId = generateId(1000, 10000);

    return (
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: uniqueId,
        }}
      >
        <div
          onClick={this.toggle}
          ref={this.dropdownRef}
          data-test-dropdown={true}
          id={uniqueId}
          tabIndex={-1}
        >
          <div
            data-test-dropdown-header={this.props.header}
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(this.toggle)}
            onKeyDown={handleEscKeyDown(this.close)}
          >
            {this.props.header}
          </div>
          {this.state.isOpen && (
            <div
              className={clsx(
                'drop-shadow-md',
                'z-[3] rounded-md border border-solid border-[#BEC0C5]',
                'absolute top-12 right-0 w-[22rem] cursor-default bg-white pt-7 text-gray-800',
              )}
              onKeyDown={handleEscKeyDown(this.close)}
              aria-labelledby={this.props.ariaLabelledby}
            >
              <div className="flex justify-between px-6 pb-3">
                <p className="text-base font-semibold ">
                  {currentUserStore.name.getOrElseValue('')}
                </p>
              </div>
              <p className="px-6 pb-7 text-sm text-gray-800">
                {currentUserStore.email.getOrElseValue('')}
              </p>
              <div className="border-t-2">
                {findLink('p3-profile-edit', currentUserStore.links)
                  .map((link) => (
                    <div className="hover:bg-gray-200 transition duration-300 ease-in-out">
                      <a
                        href={link.href}
                        className="block px-6 py-6 text-sm text-gray-800 hover:text-gray-600"
                        data-test-dropdown-item-link="My Profile"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <T kind="My Profile" />
                      </a>
                    </div>
                  ))
                  .getOrElse(() => (
                    <></>
                  ))}
                <div className="hover:bg-gray-200 transition duration-300 ease-in-out rounded-b">
                  <Link
                    className="block px-6 py-6 text-sm text-gray-800 hover:text-gray-600"
                    to="/logout"
                    data-test-dropdown-item-link="Log Out"
                    tabIndex={0}
                  >
                    <T kind="Log Out" />
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </FocusTrap>
    );
  }
}

export default Dropdown;
